var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"upper-footer",style:({
    'background-image': `url(${_vm.details.bgImage})`,
  })},[_c('v-container',{staticClass:"_wrapper"},[_c('h2',{staticClass:"relative"},[_vm._v(_vm._s(_vm.details.header))]),_c('p',{staticClass:"relative"},[_vm._v(" "+_vm._s(_vm.details.content)+" ")]),_c('v-btn',{attrs:{"depressed":"","color":"primary","to":_vm.details.ctaAction}},[_vm._v(_vm._s(_vm.details.ctaText))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }